import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import { InternalPage } from "../../../components/primitives/layout/InternalPage";
import { RequireRole } from "../../../components/gate/RequireRole";
import { useUserContext } from "../../../context/UserContext";
import { hasRole } from "../../../lib/auth";
import { useOpenState } from "../../../hooks/useOpenState";
import { BatchJobsBody } from "./BatchJobsBody";
import { NewBatchJobDialog } from "./NewBatchJobDialog";
import { useBatchJobs } from "./useBatchJobs";

/** Lists batch jobs (e.g. admission re-checks) with progress and status, newest first. Row click opens the job's detail page. */
export default function BatchJobs() {
  const { session } = useUserContext();
  const { jobs, loading, error, pagination, deleteJob, openJob, refresh } = useBatchJobs();
  const newJobDialog = useOpenState();

  return (
    <InternalPage width="full">
      <BatchJobsBody
        jobs={jobs}
        loading={loading}
        error={error}
        pagination={pagination}
        onRowClick={openJob}
        onDelete={hasRole(session?.user, "platform.admin") ? deleteJob : undefined}
        newJobAction={
          <RequireRole role="platform.admin">
            <Button variant="contained" startIcon={<AddIcon />} onClick={newJobDialog.setOpen}>
              New job
            </Button>
          </RequireRole>
        }
      />

      <NewBatchJobDialog
        open={newJobDialog.open}
        onClose={newJobDialog.setClose}
        onCreated={refresh}
      />
    </InternalPage>
  );
}
